<!-- No auto scroll when drag: https://github.com/angular/components/issues/14273 -->
<mat-dialog-content #dialog>
  <div cdkDropListGroup>
    <div class="widgets-modal-wrapper">
      <h2 mat-dialog-title>
        {{ "dashboard.reorder_select_info" | transloco }}
      </h2>
      <mat-checkbox
        [checked]="allSelected"
        (change)="selectAll($event.checked)"
        class="widgets-modal-select-all">
        {{ "operations.select_all" | transloco }}
      </mat-checkbox>
      <div
        cdkDropList
        [cdkDropListData]="assets"
        class="widgets-modal-list mt-2"
        (cdkDropListDropped)="drop($event)">
        @for (asset of assets; track asset) {
          <div
            class="widgets-modal-list-box"
            cdkDrag>
            <!--                    <mat-icon>drag_handle</mat-icon>-->
            <mat-checkbox
              class="ml-1"
              [checked]="asset.selected"
            (change)="
              asset.selected = $event.checked; selectionChanged()
            "></mat-checkbox>
            <img
              class="entity-avatar ml-3"
              alt="asset-image"
              src="{{ asset.imgGuid | lorenImage | async }}" />
            <div class="ml-3">{{ asset.title }}</div>
          </div>
        }
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>
    {{ "operations.cancel" | transloco }}
  </button>
  <button mat-button color="primary" [mat-dialog-close]="save()">
    {{ "operations.save" | transloco }}
  </button>
</mat-dialog-actions>
